export default function (element, data) {
    const branchId = data.id;
    const row = element.closest(".city-row");

    element.addEventListener("click", function () {
        if (row.classList.contains("checked")) {
            window.dispatchEvent(new CustomEvent('widgets.map.deactivateMarker', {
            }));
        } else {
            window.dispatchEvent(new CustomEvent('widgets.map.activateMarker', {
                detail: { branchId: branchId }
            }));
        }
    });

    window.addEventListener('widgets.map.activateMarker', function (event) {
        if (event.detail.branchId == branchId) {
            setTimeout(function () {
                row.classList.add("checked");
            }, 10);
        } else {
            setTimeout(function () {
                row.classList.remove("checked");
            }, 10);
        }
    });

    window.addEventListener('widgets.map.activateMarkerMap', function (event) {
        if (event.detail.branchId == branchId) {
            setTimeout(function () {
                row.classList.add("checked");
            }, 10);
        } else {
            setTimeout(function () {
                row.classList.remove("checked");
            }, 10);
        }
    });

    window.addEventListener('widgets.map.deactivateMarker', function (event) {
        setTimeout(function () {
            row.classList.remove("checked");
        }, 10);
    });
}

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary